var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React2 from "react";
import PropTypes2 from "prop-types";
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
import { MediaObject, MediaFigure, MediaBody } from "@twilio-paste/media-object";
import * as React from "react";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { ScreenReaderOnly } from "@twilio-paste/screen-reader-only";
var RequiredDot = _a => {
  var _b = _a,
    {
      element = "REQUIRED_DOT",
      i18nLabel = ""
    } = _b,
    props = __objRest(_b, ["element", "i18nLabel"]);
  return React.createElement(Box, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
    alignItems: "center",
    justifyContent: "center",
    as: "span",
    cursor: "pointer",
    display: "flex",
    height: "sizeIcon30",
    element: `${element}_WRAPPER`
  }), React.createElement(Box, {
    as: "span",
    backgroundColor: "colorBackgroundRequired",
    borderRadius: "borderRadiusCircle",
    display: "block",
    height: "4px",
    width: "4px",
    element
  }, React.createElement(ScreenReaderOnly, null, i18nLabel)));
};
RequiredDot.displayName = "RequiredDot";
var Label = React2.forwardRef((_a, ref) => {
  var _b = _a,
    {
      as = "label",
      marginBottom,
      required,
      disabled,
      children,
      variant,
      element = "LABEL",
      i18nRequiredLabel = ""
    } = _b,
    props = __objRest(_b, ["as", "marginBottom", "required", "disabled", "children", "variant", "element", "i18nRequiredLabel"]);
  let textColor = "colorText";
  disabled && variant === "inverse" ? textColor = "colorTextInverseWeak" : disabled ? textColor = "colorTextWeak" : variant === "inverse" && (textColor = "colorTextInverse");
  let cursor = "pointer";
  return disabled ? cursor = "not-allowed" : (as === "legend" || as === "div") && (cursor = "default"), React2.createElement(Box2, __spreadProps(__spreadValues({}, safelySpreadBoxProps2(props)), {
    as,
    borderBottomWidth: "borderWidth0",
    display: "block",
    marginBottom: marginBottom || "space20",
    paddingLeft: "space0",
    paddingRight: "space0",
    textTransform: "none",
    element,
    fontSize: "fontSize30",
    fontWeight: "fontWeightBold",
    lineHeight: "lineHeight30",
    color: textColor,
    cursor,
    ref
  }), React2.createElement(MediaObject, {
    verticalAlign: "top"
  }, required && React2.createElement(MediaFigure, {
    spacing: "space20"
  }, React2.createElement(RequiredDot, {
    element: `${element}_REQUIRED_DOT`,
    i18nLabel: i18nRequiredLabel
  })), React2.createElement(MediaBody, null, children)));
});
Label.displayName = "Label";
Label.propTypes = {
  as: PropTypes2.oneOf(["label", "legend", "div"]),
  disabled: PropTypes2.bool,
  element: PropTypes2.string,
  htmlFor: PropTypes2.string,
  marginBottom: PropTypes2.oneOf(["space0"]),
  required: PropTypes2.bool,
  i18nRequiredLabel: PropTypes2.string,
  variant: PropTypes2.oneOf(["default", "inverse"])
};
export { Label, RequiredDot };